<template>
  <main>
    <b-card border-variant="light">
      <div class="card-text">
        <div class="d-block">
          <span class="h6 font-weight-bold">Redigering af betalingskortoplysninger</span>
        </div>
        <span class="d-block mt-4">
          <b-btn variant="dark" @click="creditShow = !creditShow">Se kortoplysninger</b-btn>
        </span>
        <!-- Modal Component -->
        <b-modal centered id="modal-center" ref="creditModal" lazy v-model="creditShow" title="Redigering af betalingskortoplysninger">
          <div slot="modal-header">
            <div class="h5 pt-4 pb-0 font-weight-bold">Redigering af betalingskortoplysninger</div>
          </div>
          <div class="h6 pt-2 open-sans pb-0 line-height-golden">
            Hvis du har brug for at ændre dine kreditkortoplysninger, eksempelvis for at skifte et kort ud med et andet, så har du mulighed for at gøre det her.
            <br><br>
            Vi gør hermed opmærksom på at det er epay.dk (PBS) der varertager al sikkerhed omkring betalingskortoplysninger, læs mere her:
          </div>
          <div class="py-4 line-height-golden">
            <b-btn variant="dark" class="font-weight-bold"  href="http://profile.start/index.php?action=index&module=kreditkort#">
            <span class="mr2">
              <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M21 13v10h-21v-19h12v2h-10v15h17v-8h2zm3-12h-10.988l4.035 4-6.977 7.07 2.828 2.828 6.977-7.07 4.125 4.172v-11z"/></svg>
            </span>
              <span class="mr2">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M21 13v10h-21v-19h12v2h-10v15h17v-8h2zm3-12h-10.988l4.035 4-6.977 7.07 2.828 2.828 6.977-7.07 4.125 4.172v-11z"/></svg>
              </span>
            Klik her for at redigere dine kreditkortoplysninger</b-btn>
          </div>
          <div class="h6 pt-2 open-sans pb-0 line-height-golden">
            Har du spørgsmål eller brug for support, så ring meget gerne til kundeservice på 70 22 80 14 eller skriv til <a>info@imentor.dk</a>.
            <br><br>Vi gemmer via Nets dine kreditkortoplysninger til betaling af fremtidige møder. Vi gemmer oplysningerne indtil kortet skiftes. Ønsker du i fremtiden at benytte en anden form for betaling, så kontakt os venligst på <a>70 22 80 14</a>.
          </div>
          <!-- modalFooter -->
          <div slot="modal-footer">
            <b-row class="pt-0 pb-4">
              <!-- <b-col><b-btn type="submit" slot="modal-ok" variant="success" size="lg">Ok</b-btn></b-col> -->
              <b-col><b-btn type="reset" slot="modal-cancel" variant="outline-dark" size="lg" @click="closeCreditModal" class="">Luk</b-btn></b-col>
            </b-row>
          </div>
        </b-modal>
      </div>
    </b-card>
  </main>
</template>
<script>
export default {
  name: 'textcreditcard',
  data () {
    return {
      creditShow: false
    }
  },
  methods: {
    closeCreditModal () {
      this.$refs.creditModal.hide()
    }
  }
}
</script>


// WEBPACK FOOTER //
// textCreditcard.vue?97ae20ce